type JsonSchemeComponent = {
  type: string;
  children?: JsonSchemeComponent[] | JsonSchemeComponent | string | null;
  props?: Record<
    string | number,
    string | number | boolean | JsonSchemeComponent | JsonSchemeComponent[]
  >;
};

export const mapJsonSeatScheme = (
  createElement: (
    type: JsonSchemeComponent['type'],
    props: JsonSchemeComponent['props'],
    chld: JsonSchemeComponent['children'],
  ) => any,
  registry: { get: (name: string) => any; UnknownType: string },
  scheme?: JsonSchemeComponent | JsonSchemeComponent[] | null | string | number,
): any => {
  if (!scheme) return null;

  if (typeof scheme === 'string' || typeof scheme === 'number') return scheme;
  if (Array.isArray(scheme))
    return scheme.map((item: JsonSchemeComponent) =>
      mapJsonSeatScheme(createElement, registry, item),
    );

  const typeIsComponent = scheme.type[0] === scheme.type[0].toUpperCase();

  if (typeIsComponent) {
    const Comp = registry.get(scheme.type);

    if (!Comp) return createElement(registry.UnknownType, {}, '??');

    return createElement(
      Comp,
      scheme.props,
      mapJsonSeatScheme(createElement, registry, scheme.children),
    );
  }

  return createElement(registry.UnknownType, {}, '??');
};
